import * as React from "react";
import {useState} from "react";

import {Input}    from "../input";

import "./phoneFieldPrefAndExt.scss";


export const PhoneFieldPrefAndExt = ({specField, fullData}) => {

    const prefixField = fullData.find( field => field.fieldKey === specField.prefixField);
    const extensionPrefixField = fullData.find( field => field.fieldKey === specField.extensionPrefixField);
    const phoneField = fullData.find( field => field.fieldKey === specField.fieldKey.slice(0, -15));
    const extensionField = fullData.find( field => field.fieldKey === specField.extensionField);

    const [prefixValue, setPrefixValue] = useState(prefixField ? prefixField.data : null);
    const [extensionPrefixValue, setExtensionPrefixValue] = useState(extensionPrefixField ? extensionPrefixField.data : null);
    const [phoneValue, setPhoneValue] = useState(phoneField ? phoneField.data : null);
    const [extensionValue, setExtensionValue] = useState(extensionField ? extensionField.data : null);

    // restrict phone number & extension number inputs to charactes allowed in 2.9
    const allowedChars = /^[0-9 x\(\)%\*\+\.\'\"#¾]*$/;

    function changeHandlerPhone (event) {
        const newVal = event.target.value;
        if (allowedChars.test(newVal) && newVal.length <= 25) {
            setPhoneValue(newVal);
            fullData.find( field => field.fieldKey === specField.fieldKey.slice(0, -15)).onChange(newVal);
        }
    }

    function changeHandlerExtension (event) {
        const newVal = event.target.value;
        if (allowedChars.test(newVal) && newVal.length <= 10) {
            setExtensionValue(newVal);
            fullData.find( field => field.fieldKey === specField.extensionField).onChange(newVal);
        }
    }

    return(
        <div className="phone-field-pref-and-ext-17g">
            <div className="multi-field-label">{specField.displayLabel}</div>
            <div className="multipart-phone-field">

                {/* // dropdown for the prefix */}
                <select className="multi-field-dropdown"
                    defaultValue=""
                    name={specField.fieldKey}
                    value={prefixValue}
                    data-ignoreSave="true"
                    onChange={async (event) => {
                        const newVal = event.target.value;
                        setPrefixValue(newVal);
                        let foundField = fullData.find( field => field.fieldKey === specField.prefixField);
                        foundField.onChange(newVal);
                    }}
                    data-fieldname={specField.displayLabel}
                    xd-qa-type="dropdown"
                    xd-qa-name={"order_data["+specField.prefixField+"][data]"}
                >
                    <option value="" xd-qa-type="dropdown_item" xd-qa-name="default">
                        None
                    </option>
                    {
                        specField.prefixOptions?.map((value) =>
                            <option key={value} value={value} xd-qa-type="dropdown_item" xd-qa-name={value}>
                                {value}
                            </option>
                        )
                    }
                </select>

                {/* // input for the phone number */}
                <Input
                    inputField
                    inputFieldName={specField.fieldKey}
                    inputType="tel"
                    dataFieldName={specField.displayLabel}
                    fieldValue={phoneValue}
                    className='phone-field-input'
                    changeHandler={(event) => changeHandlerPhone(event)}
                    extraInfo={{ "data-ignoreSave": "true" }}
                />

                {/* // dropdown for the extension prefix (if present)*/}
                {extensionPrefixField ? <select className="multi-field-dropdown"
                    defaultValue=""
                    name={specField.fieldKey}
                    value={extensionPrefixValue}
                    data-ignoreSave="true"
                    onChange={async (event) => {
                        const newVal = event.target.value;
                        setExtensionPrefixValue(newVal);
                        let foundField = fullData.find( field => field.fieldKey === specField.extensionPrefixField);
                        if (foundField) {
                            foundField.onChange(newVal);
                        }
                    }}                    
                    data-fieldname={specField.displayLabel}
                    xd-qa-type="dropdown"
                    xd-qa-name={"order_data["+specField.prefixField+"][data]"}
                >
                    <option value="" xd-qa-type="dropdown_item" xd-qa-name="default">
                        None
                    </option>
                    <option value="x" xd-qa-type="dropdown_item" xd-qa-name="default">
                        x
                    </option>
                </select> : null}

                {/* // input for the extension number (if present)*/}
                {extensionField ? <Input
                    inputField
                    inputFieldName={specField.fieldKey}
                    inputType="text"
                    dataFieldName={specField.displayLabel}
                    fieldValue={extensionValue}
                    className='extension-field-input'
                    changeHandler={(event) => changeHandlerExtension(event)}
                    extraInfo={{ "data-ignoreSave": "true" }}
                /> : null}
            </div>


        </div>
    );
}